module.exports = __webpack_public_path__ + "static/20260807_ Extension_Expiration_Date-afd6591feaa5e37c707801476e17dca0.pdf";